import React from 'react';
import styled from 'styled-components';
import Link from 'components/Link';
import { ButtonBlock } from 'components/theme/Button/Button';

const NotFoundWrapper = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 20px;

  & a {
    padding-left: 20px;
    padding-right: 20px;
    margin-bottom: 20px;
  }
`;

const ViewAllExperiencesButton = styled(ButtonBlock)`
  && {
    width: fit-content;
    color: var(--way-colors-buttonColorContrastShades-80);
    &:hover {
      color: var(--way-colors-buttonColorContrastShades-100);
    }
  }
`;

const EmptyCartError = () => (
  <NotFoundWrapper>
    <p>The cart is empty.</p>
    <ViewAllExperiencesButton as={Link} to="/experiences">
      View All Experiences
    </ViewAllExperiencesButton>
  </NotFoundWrapper>
);

export default EmptyCartError;
